import React, { useEffect, useState, useMemo, useRef } from 'react'
import { Link, useRouteMatch, Switch, Route } from 'react-router-dom';
import { useHistory } from "react-router-dom";


import {
   Col,
   Row,
   Card,
   CardHeader,
   CardBody,
   CardTitle,
   Nav,
   NavItem,
   NavLink,
   Button,
   Badge,
   UncontrolledTooltip
} from 'reactstrap'
import {
   exportInventory,
} from 'services/dataservice';
import ReactTable from "components/ReactTable/ReactTable.js";
import ReactBSAlert from 'react-bootstrap-sweetalert';
import Notify from 'react-notification-alert';
import moment from "moment";

import "./InventoryByZone.css";
import { getInventoryLocation } from 'services/dataservice';

export default function InventoryByZone(prop) {
   const columns = useMemo(() => [
      {
         Header: "SKU",
         accessor: "skuCode",
         disableFilters: false,
         Cell: ({ row }) => <Link to={
            {
               pathname: `/admin/inventory-movement/list`,
               state: {
                  skuCode: row.original.skuCode,
                  mln: row.original.mln,
                  expiryDate: row.original.expiryDate
               }
            }
         }>{row.original.skuCode}</Link>
      },
      {
         Header: "Product Name",
         accessor: "productName"
      },
      {
         Header: "Expiry Date",
         accessor: "expiryDate",
         style: { 'whiteSpace': 'unset' }
      },
      {
         Header: "MLN",
         accessor: "mln"
      },
      {
         Header: "Warehouse Qty", // change to total
         accessor: "warehouseQuantity",
         disableFilters: true
      },
      {
         Header: "Committed", //this is Open SO, minus out on first line for same sku
         accessor: "committedQuantity",
         disableFilters: true
      },
      {
         Header: "Allocated", //this is Allocated SO
         accessor: "allocatedQuantity",
         disableFilters: true
      },
      {
         Header: "Hold",//change to only hold
         accessor: "holdQty",
         disableFilters: true
      },
      {
         Header: "Available", //total minus all
         accessor: "availableQuantity",
         disableFilters: true
      },
   ])


   let { path, url } = useRouteMatch();
   const [alert, setAlert] = useState(null);
   const [tableData, setTableData] = useState([]);
   const [tabs, setTabs] = useState("all");
   const [statusCount, setStatusCount] = useState({ all: 0, stockAvailable: 0, outOfStock: 0, preOrder: 0, deleted: 0 });
   let history = useHistory();

   const [filteredData, setFilteredData] = useState([])

   const notify = useRef(null);

   useEffect(() => {
      reloadList();
   }, []);

   function reloadList() {
      getInventoryLocation().then(res => {
         if (res.data) {
            setTableData(res.data.map((res, index) => {
               return {
                  ...res
               }
            }));
            setFilteredData(res.data.map((res, index) => {
               return {
                  ...res
               }
            }))
         }
      });
   }

   const triggerExport = async () => {
      const date = new Date()
      const dateStr = moment(date).format("YYYYMMDDHHmmss")
      const headers = columns.map(h => h.Header);

      const escapeCSV = (value) => {
         if (value == null) return '';
         const str = value.toString().replace(/"/g, '""');
         return /[",\n]/.test(str) ? `"${str}"` : str;
      };

      const rows = filteredData.map(row =>
         headers.map(h => {
            const key = columns.find(c => c.Header === h)?.accessor || h;
            return escapeCSV(row[key]);
         }).join(",")
      );

      const csvContent = [headers.join(","), ...rows].join("\n");

      const url = window.URL.createObjectURL(new Blob([csvContent], { type: "text/csv" }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Inventory_By_Zone_${dateStr}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

   }

   return (
      <div className="content" style={{ "minWidth": "1200px" }}>
         {alert}
         <Notify ref={notify} />
         <Row className="row justify-content-end">
            <Col md="12" className="d-flex flex-row-reverse">
               <Button color="primary" onClick={triggerExport}>Export</Button>
            </Col>
         </Row>
         <Row>
            <Col md="12">
               <Card className="card-subcategories">
                  <CardHeader>
                     <CardTitle tag="h4">Inventory By Zone</CardTitle>
                  </CardHeader>
                  <CardBody>
                     <ReactTable
                        data={tableData}
                        columns={columns}
                        setFilteredData={setFilteredData}
                        className="-striped -highlight primary-pagination">
                     </ReactTable>
                  </CardBody>
               </Card>
            </Col>
         </Row>
      </div >
   )
}